import { Spinner } from "react-bootstrap";

const LoadingGroupPage = () => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
      }}
    >
      <Spinner animation="border" />
    </div>
  );
};

export default LoadingGroupPage;
